import { type PropsWithChildren, useMemo, useState } from "react";

import { initialSortValue } from "@/features/flights/utils/initialFlightsValues";

import {
  FlightSortContext,
  type FlightSortContextValue,
} from "./FlightSortContext";

export const FlightSortProvider = ({ children }: PropsWithChildren) => {
  const [sortValue, setSortValue] =
    useState<FlightSortContextValue["sortValue"]>(initialSortValue);

  const contextValue = useMemo<FlightSortContextValue>(
    () => ({
      sortValue,
      updateSortValue: setSortValue,
      resetSortValue: () => setSortValue(initialSortValue),
    }),
    [sortValue],
  );

  return (
    <FlightSortContext.Provider value={contextValue}>
      {children}
    </FlightSortContext.Provider>
  );
};
